/** URL state of the stakeholders list so the editor round-trip and analytics drill-downs keep the filters. */
export interface StakeholderSearch {
  q?: string;
  region?: string;
  engagement?: string;
  importance?: string;
  entity_type?: string;
  has_programs?: '1';
  linked?: '1';
  sort?: string;
  page?: number;
  analytics?: '1';
}

const str = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v : undefined);

export function parseStakeholderSearch(raw: Record<string, unknown>): StakeholderSearch {
  const page = Number(raw.page);
  return {
    q: str(raw.q),
    region: str(raw.region),
    engagement: str(raw.engagement),
    importance: str(raw.importance),
    entity_type: str(raw.entity_type),
    has_programs: raw.has_programs === '1' || raw.has_programs === 1 || raw.has_programs === true ? '1' : undefined,
    linked: raw.linked === '1' || raw.linked === 1 || raw.linked === true ? '1' : undefined,
    sort: str(raw.sort),
    page: Number.isInteger(page) && page > 1 ? page : undefined,
    analytics: raw.analytics === '1' || raw.analytics === 1 || raw.analytics === true ? '1' : undefined,
  };
}

/** URL state of the enablement-programs page. */
export interface ProgramsSearch {
  view?: 'grouped' | 'flat';
  all?: '1';
  q?: string;
  page?: number;
}

export function parseProgramsSearch(raw: Record<string, unknown>): ProgramsSearch {
  const page = Number(raw.page);
  const view = str(raw.view);
  return {
    view: view === 'flat' ? 'flat' : view === 'grouped' ? 'grouped' : undefined,
    all: raw.all === '1' || raw.all === 1 || raw.all === true ? '1' : undefined,
    q: str(raw.q),
    page: Number.isInteger(page) && page > 1 ? page : undefined,
  };
}
